import { FaMinus, FaPlus } from 'react-icons/fa6';

const AccessoryUpsellHeader = ({ isExpanded, toggleIsExpanded, title, subheader }) => {
  return (
    <div
      className='tw:flex tw:cursor-pointer tw:select-none tw:items-center tw:justify-between tw:gap-4'
      onClick={toggleIsExpanded}>
      <div>
        <p className='tw:mb-0 tw:text-base tw:font-normal tw:md:mb-1 tw:md:last:mb-0'>{title}</p>
        {subheader && (
          <p className='tw:mb-0 tw:text-2xs tw:font-normal tw:leading-tight tw:text-gray-dark tw:md:text-[11px]'>
            {subheader}
          </p>
        )}
      </div>

      {isExpanded ? (
        <FaMinus size={20} className='tw:text-body' />
      ) : (
        <FaPlus size={20} className='tw:text-body' />
      )}
    </div>
  );
};

export default AccessoryUpsellHeader;
